import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useCaBankAccountForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      accountNumber: bankDetails?.canadianBankAccount?.accountNumber ?? '',
      institutionNumber:
        bankDetails?.canadianBankAccount?.institutionNumber ?? '',
      transitNumber: bankDetails?.canadianBankAccount?.transitNumber ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'accountNumber',
        validation: [required]
      },
      {
        property: 'institutionNumber',
        validation: [required]
      },
      {
        property: 'transitNumber',
        validation: [required]
      }
    ]
  })
}

export const CaBankAccountForm = ({
  fields
}: {
  fields: ReturnType<typeof useCaBankAccountForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="Account name" htmlFor="account-name">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="account-name"
        value={fields.accountNumber.value}
        validationErrors={fields.accountNumber.validationErrors}
        onChange={e => {
          fields.accountNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl
      label="Institution number"
      htmlFor="institution-number"
    >
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="institution-number"
        value={fields.institutionNumber.value}
        validationErrors={fields.institutionNumber.validationErrors}
        onChange={e => {
          fields.institutionNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>

    <SettingsFormControl label="Transit number" htmlFor="transit-number">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="transit-number"
        value={fields.transitNumber.value}
        validationErrors={fields.transitNumber.validationErrors}
        onChange={e => {
          fields.transitNumber.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
